module.exports = __webpack_public_path__ + "static/img/google-icon.1c6e97b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/google-icon.png
// module id = 351
// module chunks = 1